import React, { Component } from 'react'
import { Table } from 'antd'
import moment from 'moment'

class ListChangeOrderEstimates extends Component {
  getColumns = () => {
    return [
      {
        title: 'Id',
        dataIndex: 'job',
        render: item => {
          if (item && item.job_type) {
            let jobUrl = `/jobView/${item.job_id}/${item.job_type.replace(
              '/',
              '-'
            )}/site-estimates/modal/${item.id}`
            return (
              <a href={jobUrl} target="_blank">
                {item.id}
              </a>
            )
          }
        }
      },
      {
        title: 'Description',
        dataIndex: 'description'
      },
      {
        title: 'Created Date',
        dataIndex: 'created_date'
      }
    ]
  }

  getData = () => {
    const { changeOrderEstimates } = this.props

    const data = changeOrderEstimates.map((changeOrderEstimate, index) => {
      // format date from db
      changeOrderEstimate.created_date = moment(new Date(changeOrderEstimate.created_date)).format(
        'YYYY-MM-DD'
      )
      const returnObj = Object.assign(
        {
          key: `${changeOrderEstimate.id}${index}`,
          job: {
            job_id: changeOrderEstimate.job_id,
            job_type: changeOrderEstimate.job_type,
            number: changeOrderEstimate.number,
            id: changeOrderEstimate.id
          }
        },
        changeOrderEstimate
      )
      return returnObj
    })
    return data
  }

  render() {
    return (
      <div>
        <h6>Change Order Estimates</h6>
        <Table
          pagination={false}
          columns={this.getColumns()}
          dataSource={this.getData()}
          size="small"
          style={{ backgroundColor: 'white' }}
        />
      </div>
    )
  }
}

export default ListChangeOrderEstimates



// WEBPACK FOOTER //
// ./src/components/reports/general/open-items/ListChangeOrderEstimates.js